type ResolveEditorBillRateParams = {
  isNew: boolean
  originalPositionId?: number
  currentPositionId?: number
  shiftBillRate?: number
  positionBillRate?: number | string | null
}

export function resolveEditorBillRate({
  isNew,
  originalPositionId,
  currentPositionId,
  shiftBillRate,
  positionBillRate,
}: ResolveEditorBillRateParams) {
  const positionChanged =
    !isNew &&
    originalPositionId != null &&
    currentPositionId != null &&
    currentPositionId !== originalPositionId

  const usePositionBillRate = isNew || positionChanged

  const billRate = usePositionBillRate
    ? positionBillRate != null
      ? Number(positionBillRate)
      : undefined
    : shiftBillRate

  return { usePositionBillRate, billRate }
}
